module.exports = __webpack_public_path__ + "img/draw-query-compound.4c7eeabc.gif";